import _Promise from 'babel-runtime/core-js/promise';
import _regeneratorRuntime from 'babel-runtime/regenerator';
import _asyncToGenerator from 'babel-runtime/helpers/asyncToGenerator';
import _extends from 'babel-runtime/helpers/extends';

import { mapState, mapMutations, mapActions } from 'vuex';
import GroupItem from './group-item.vue';
import Layout from '../components/layout.vue';
import Outline from '../components/outline.vue';
import Category from '../components/category.vue';
import Search from '../components/category-search.vue';
import AddLocalResourceDialog from './add-local-resource-dialog.vue';
import PackagePreviewer from './package-previewer.vue';
import AddRepositoryResourceDialog from './add-repository-resource-dialog.vue';
import AddLocalResourceInZipDialog from '../components/add-local-resource-in-zip-dialog.vue';
import ResourceCloudSelectionDialog from './resource-cloud-selection-dialog.vue';
import EditResourcePopup from './edit-resource-popup.vue';
import VersionSide from './sidebar/index.vue';
import Navbar from './navbar.vue';
import PushDialog from '../../../../../playturbo/src/components/pushDialog.vue';
import _isMaterialWarehouse from '@/common/is-warehouse.js';
import SkinList from '@/views/creative/template/skin-management/skin-list.vue';
import ModelConversion from '@com/components/model-conversion/index.vue';
import AssetDialog from '@com/components/asset-dialog';
import ResourceManager from '@com/components/resource-manager/dialog.vue';
import UploaderResToAsset from './uploader-res-to-asset.vue';
import ModelUploadSpecification from './model-upload-specification.vue';
import ForbiddenFontDialog from '@com/components/forbidden-font-dialog';
import { dealForbiddenFont } from '@/utils/checkJsonConfigForbiddenFont';
import { setDocumentTitle } from '@pt/utils/documentTitle';
import ptTracker from '@pt/metrics-tracking/playturbo-collector';
import DetailDrawer from '@pt/views/common-template/components/detail-drawer/index.vue';
import templatePreviewerDialog from '@pt/views/common-template/components/template-previewer-dialog.vue';
import { PtBusinessType } from '@pt/components/common-push-dialog/config';
import ModelEditor from '@/views/creative/model-editor/index.vue';
import _ from 'lodash';
import ModelProcessingServiceDialog from '@pt/views/common-template/components/model-processing-service-dialog/index.vue';
import PageStayTracker from '@com/metrics-tracking/page-stay-tracker';
import { ptTrackEvent } from '@com/utils/report-logs/pt';

export default {
  components: {
    SkinList: SkinList,
    PackagePreviewer: PackagePreviewer,
    Outline: Outline,
    ResourceCloudSelectionDialog: ResourceCloudSelectionDialog,
    AddRepositoryResourceDialog: AddRepositoryResourceDialog,
    AddLocalResourceDialog: AddLocalResourceDialog,
    AddLocalResourceInZipDialog: AddLocalResourceInZipDialog,
    // DownloadTaskDialog,
    Layout: Layout,
    Search: Search,
    Category: Category,
    EditResourcePopup: EditResourcePopup,
    VersionSide: VersionSide,
    Navbar: Navbar,
    PushDialog: PushDialog,
    ModelConversion: ModelConversion,
    AssetDialog: AssetDialog,
    ResourceManager: ResourceManager,
    UploaderResToAsset: UploaderResToAsset,
    ForbiddenFontDialog: ForbiddenFontDialog,
    DetailDrawer: DetailDrawer,
    templatePreviewerDialog: templatePreviewerDialog,
    ModelEditor: ModelEditor,
    ModelProcessingServiceDialog: ModelProcessingServiceDialog,
    ModelUploadSpecification: ModelUploadSpecification
  },

  props: {},

  data: function data() {
    return {
      loading: true,
      pageStayTracker: null,
      saveBarVisible: false,
      GroupItem: GroupItem,
      saving: false,
      modelProcessingData: {
        visible: false,
        loading: false
      }
    };
  },


  computed: _extends({
    pushBusiness: function pushBusiness() {
      var routeName = this.$route.name;

      var hash = {
        // 普通制作
        'common-template.custom': PtBusinessType.Normal,
        // 定制-普通制作
        'template.custom': PtBusinessType.CustomNormal
      };

      return hash[routeName];
    }
  }, mapState({
    pushDialog: function pushDialog(state) {
      return state.creative.pusher.pushDialog;
    },
    templateId: function templateId(state) {
      return state.creative.template.id;
    },
    templateConfig: function templateConfig(state) {
      return state.creative.template.templateConfig || {};
    },
    hasJsonConfig: function hasJsonConfig(state) {
      return state.creative.template.hasJsonConfig;
    },
    hasModelResource: function hasModelResource(state) {
      return state.creative.template.hasModelResource;
    },
    previewUrl: function previewUrl(state) {
      return state.creative.template.previewUrl;
    },
    activeCategoryId: function activeCategoryId(state) {
      return state.creative.template.activeCategoryId;
    },
    currentCategory: function currentCategory(state) {
      return state.creative.template.currentCategory;
    },
    currentResource: function currentResource(state) {
      return state.creative.template.currentResource;
    },
    currentResourceInZip: function currentResourceInZip(state) {
      return state.creative.template.currentResourceInZip;
    },
    addLocalResourceInZipDialog: function addLocalResourceInZipDialog(state) {
      return state.creative.template.addLocalResourceInZipDialog;
    },
    editResourceDialog: function editResourceDialog(state) {
      return state.creative.template.editResourceDialog;
    },
    validateList: function validateList(state) {
      return state.creative.template.validateList;
    },
    menuTransferDialog: function menuTransferDialog(state) {
      return state.creative.template.menuTransferDialog;
    },
    page: function page(state) {
      return state.creative.template.page;
    },
    permissions: function permissions(state) {
      return state.creative.template.permissions;
    },
    gameConfigResource: function gameConfigResource(state) {
      return state.creative.template.gameConfigResource || null;
    },
    outlineCategory: function outlineCategory(state) {
      return state.creative.template.outline.category;
    },
    isReadonly: function isReadonly(state) {
      return state.creative.template.isReadonly;
    },
    isPreviewBasicPackage: function isPreviewBasicPackage(state) {
      return state.creative.template.isPreviewBasicPackage;
    },
    canLivePreview: function canLivePreview(state) {
      return state.creative.template.canLivePreview;
    },
    assetsDialog: function assetsDialog(state) {
      return state.creative.asset.assetsDialog;
    },
    resourceManagersDialog: function resourceManagersDialog(state) {
      return state.creative.asset.resourceManagersDialog;
    },
    forbiddenFontDialog: function forbiddenFontDialog(state) {
      return state.creative.forbiddenFont.forbiddenFontDialog;
    },
    i18nResource: function i18nResource(state) {
      return state.creative.template.i18nResource;
    },
    creativePreviewerDialog: function creativePreviewerDialog(state) {
      return !_isMaterialWarehouse() ? state.pt.delivery.creativePreviewerDialog : {};
    },
    creativePreviewer: function creativePreviewer(state) {
      return !_isMaterialWarehouse() ? state.pt.delivery.creativePreviewer : {};
    },
    isCommonTemplateCustom: function isCommonTemplateCustom(state) {
      return state.creative.template.isCommonTemplateCustom;
    },
    hasCocosModel: function hasCocosModel(state) {
      return state.creative.template.hasCocosModel;
    },
    hasMvPlayable: function hasMvPlayable(state) {
      return state.creative.template.hasMvPlayable;
    },
    isCreativeTemplateCustom: function isCreativeTemplateCustom(state) {
      return state.creative.template.isCreativeTemplateCustom;
    }
  }), {
    isLoading: function isLoading() {
      return this.loading;
    },
    activeCategory: function activeCategory() {
      var _this = this;

      if (this.templateConfig.category) {
        var category = {};

        var rec = function rec(data) {
          data.forEach(function (item) {
            if (item.id === _this.activeCategoryId) {
              category = item;
            } else if (item.sub_category) {
              rec(item.sub_category);
            }
          });
        };
        rec(this.templateConfig.category);
        return category;
      }

      return {};
    },
    category: function category() {
      return this.templateConfig.category;
    },
    clsName: function clsName() {
      var clsName = 'app-container playable-template-maker playable-' + this.page;
      clsName = this.isReadonly ? clsName + ' read-only' : clsName;
      return clsName;
    },


    // 只有 laya 的素材才会展示模型转换器, cocos 的不需要这个东西
    showLmConversion: function showLmConversion() {
      return this.hasModelResource && !this.hasCocosModel;
    },
    showCocosEditor: function showCocosEditor() {
      return this.hasCocosModel && this.hasMvPlayable;
    },
    isModelResourceDialog: function isModelResourceDialog() {
      return _.get(this.resourceManagersDialog, 'model.type') === 'model';
    }
  }),

  watch: {
    $route: function $route() {
      this.destroy();
      this.$store.dispatch('config/getFontList');
      if (!_isMaterialWarehouse()) {
        // 加载自定义字体给样式编辑模板使用
        this.$store.dispatch('assets/resource/getAssetFontList');
      }
      this.init();
    },

    'resourceManagersDialog.model': {
      handler: function handler(newVal, oldVal) {
        var _this2 = this;

        // 只有在打开状态下切换类型才会触发 模型数据skeleton_type变化也会触发刷新
        if (this.resourceManagersDialog.visible && (newVal.type && oldVal.type && newVal.type !== oldVal.type || newVal.skeleton_type && oldVal.skeleton_type && newVal.skeleton_type !== oldVal.skeleton_type)) {
          // 确保拉取数据是在在赋值之后拉取
          this.$nextTick(function () {
            // 拉取最新类型的数据
            _this2.initRefresh();
          });
        }
      },

      deep: true
    },
    'templateConfig.name': {
      handler: function handler(newVal) {
        setDocumentTitle(newVal);
      },

      immediate: true
    }
  },

  mounted: function mounted() {
    var _this3 = this;

    return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
      var action;
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return _this3.$store.dispatch('config/getFontList');

            case 2:
              if (_isMaterialWarehouse()) {
                _context.next = 5;
                break;
              }

              _context.next = 5;
              return _this3.$store.dispatch('assets/resource/getAssetFontList');

            case 5:
              if (!_isMaterialWarehouse()) {
                action = ptTrackEvent.createAction();
                // pt使用时长监控

                if (_this3.pageStayTracker) {
                  _this3.pageStayTracker.destroy();
                  _this3.pageStayTracker = null;
                }
                _this3.pageStayTracker = new PageStayTracker({
                  reportFunction: function reportFunction(_ref) {
                    var duration = _ref.duration,
                        interactive = _ref.interactive;

                    action.log({
                      e: 'active',
                      d: duration,
                      act: interactive,
                      extra: {
                        pid: _this3.$route.params.customId,
                        project_type: _this3.$route.name.indexOf('common-template.custom') > -1 ? 'gm' : 'dm'
                      }
                    });
                  }
                });
                _this3.pageStayTracker.startReporting();
              }
              _this3.init();

            case 7:
            case 'end':
              return _context.stop();
          }
        }
      }, _callee, _this3);
    }))();
  },
  beforeDestroy: function beforeDestroy() {
    this.destroy();
  },


  methods: _extends({}, mapMutations({
    updateActiveCategoryId: 'creative/template/updateActiveCategoryId',
    updateActiveCategoryNode: 'creative/template/updateActiveCategoryNode',
    closeAddLocalResourceInZipDialog: 'creative/template/closeAddLocalResourceInZipDialog',
    updateCurrentCategory: 'creative/template/updateCurrentCategory',
    updateCurrentResource: 'creative/template/updateCurrentResource',
    updateCurrentResourceInZip: 'creative/template/updateCurrentResourceInZip',
    closeEditResourceDialog: 'creative/template/closeEditResourceDialog',
    emptyValidator: 'creative/template/emptyValidator',
    openMenuTransferDialog: 'creative/template/openMenuTransferDialog',
    closeMenuTransferDialog: 'creative/template/closeMenuTransferDialog',
    updateSortMenuDialog: 'creative/template/updateSortMenuDialog',
    setConversionFrame: 'creative/template/model/setConversionFrame',
    updateAssetsDialog: 'creative/asset/updateAssetsDialog',
    updateForbiddenFontDialog: 'creative/forbiddenFont/updateForbiddenFontDialog',
    updateI18nResourceByReplace: 'creative/template/updateI18nResourceByReplace',
    setCategoryId: 'creative/modelOrder/setCategoryId'
  }), mapActions({
    updateGameReady: 'creative/template/previewer/updateGameReady',
    updateCanLivePreview: 'creative/template/previewer/updateCanLivePreview',
    previewImage: 'creative/template/previewer/previewImage',
    getTemplateOriginalInfo: 'creative/template/getTemplateOriginalInfo',
    autoSaveTemplate: 'creative/template/autoSaveTemplate',
    removeAutoSave: 'creative/template/removeAutoSave',
    initBaseConfig: 'creative/template/initBaseConfig',
    updateResource: 'creative/template/updateResource',
    addAssetToProject: 'creative/asset/addAssetToProject',
    getOrderList: 'creative/modelOrder/getOrderList'
  }), {
    handAddResource: function handAddResource(data) {
      if (data.public || data.file && data.file.public) {
        var action = ptTrackEvent.createAction();
        var resourceId = data.id || data.file.id;
        action.log({
          e: 'use_asset',
          extra: {
            pid: this.$route.params.customId,
            asset_id: resourceId,
            project_type: this.$route.name.indexOf('common-template.custom') > -1 ? 'gm' : 'dm'
          }
        });
      }
      this.addAssetToProject(data);
    },
    handlePushSuccess: function handlePushSuccess() {
      console.log('推送成功监听');
      if (this.$refs['navbar'].$refs['package-manager']) {
        this.$refs['navbar'].$refs['package-manager'].getDownloadCount();
      }
    },
    isMaterialWarehouse: function isMaterialWarehouse() {
      return _isMaterialWarehouse();
    },
    documentClickHandler: function documentClickHandler() {
      if (this.editResourceDialog.closable === true && this.editResourceDialog.visible === true && this.resourceManagersDialog.visible === false // 如果资源管理器打开，不能关闭详情页弹框，不然会无法更新资源
      ) {
          this.closeEditResourceDialog();
        }
    },
    messageHandler: function messageHandler(e) {
      if (e.data && e.data.type === 'previewer:gameReady') {
        console.log('接收到 gameReady 事件');
        ptTracker.stopEvent({
          pid: this.$route.params.customId,
          extra: {
            template_id: this.$route.params.templateId,
            custom_id: this.$route.params.customId,
            skin_id: this.$route.params.skinId
          }
        });
        this.updateGameReady(true);
        this.updateCanLivePreview(this.canLivePreview);
        this.$refs.packagePreviewer && this.$refs.packagePreviewer.initAudioState();
      }
    },
    resetState: function resetState() {
      this.loading = true;
      this.$store.commit('creative/template/resetState');
      this.$store.commit('creative/template/previewer/resetState');
    },
    validate: function validate() {
      var _this4 = this;

      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2() {
        var valid;
        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                if (!(_this4.validateList.length > 0)) {
                  _context2.next = 19;
                  break;
                }

                _context2.prev = 1;
                _context2.next = 4;
                return _Promise.all(_this4.validateList.filter(function (item) {
                  return item && typeof item.validate === 'function';
                }).map(function (item) {
                  return item.validate();
                }));

              case 4:
                valid = _context2.sent;

                if (!valid.every(function (item) {
                  return item === true;
                })) {
                  _context2.next = 8;
                  break;
                }

                _this4.emptyValidator();
                return _context2.abrupt('return', true);

              case 8:
                _this4.validateFail();
                _context2.next = 17;
                break;

              case 11:
                _context2.prev = 11;
                _context2.t0 = _context2['catch'](1);

                console.error(_context2.t0);
                _this4.$gtag && _this4.$gtag.exception({
                  description: _context2.t0,
                  fatal: false
                });
                _this4.validateFail(_context2.t0.message);
                return _context2.abrupt('return', false);

              case 17:
                _context2.next = 21;
                break;

              case 19:
                _this4.emptyValidator();
                return _context2.abrupt('return', true);

              case 21:
                return _context2.abrupt('return', true);

              case 22:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, _this4, [[1, 11]]);
      }))();
    },
    validateFail: function validateFail(message) {
      this.$message.error(message || this.$t('playTurbo.creative.templateMixin.error'));
    },
    init: function init() {
      var _this5 = this;

      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3() {
        return _regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                // 避免记录了弹框状态
                if (_this5.resourceManagersDialog.visible) {
                  _this5.resourceManagersDialog.visible = false;
                }
                _this5.triggerWinResize();
                document.addEventListener('click', _this5.documentClickHandler);
                window.addEventListener('message', _this5.messageHandler);
                _context3.next = 6;
                return _this5.initBaseConfig({ router: _this5.$route });

              case 6:
                if (!_this5.isCommonTemplateCustom) {
                  _context3.next = 9;
                  break;
                }

                _context3.next = 9;
                return _this5.$store.dispatch('assets/resource/getAssetFontList');

              case 9:
                _context3.next = 11;
                return _this5.getTemplateInfo();

              case 11:
                _context3.next = 13;
                return _this5.$store.dispatch('creative/template/previewTemplate');

              case 13:
                if (_this5.hasModelResource) {
                  console.log('模板iframe', document.querySelector('#model-conversion'));
                  if (document.querySelector('#model-conversion')) {
                    _this5.setConversionFrame(document.querySelector('#model-conversion'));
                  }
                }
                _this5.$store.dispatch('creative/modelEditor/addListenerEvent');
                // 如果替换模型场景，替换完模型再移除 loading

                if (!(_this5.$route.query && _this5.$route.query.fileUrl)) {
                  _context3.next = 20;
                  break;
                }

                _this5.loading = true;
                _context3.next = 19;
                return _this5.$store.dispatch('creative/modelOrder/convertCocosModelByQuery', _this5.$route.query);

              case 19:
                _this5.loading = false;

              case 20:
                if (!_this5.isCommonTemplateCustom) {
                  _context3.next = 23;
                  break;
                }

                _context3.next = 23;
                return _this5.getOrderList({
                  search_field: 'project_id',
                  keyword: _this5.templateId,
                  page: 1,
                  page_size: 1000
                });

              case 23:
              case 'end':
                return _context3.stop();
            }
          }
        }, _callee3, _this5);
      }))();
    },
    destroy: function destroy() {
      this.resetState();
      this.removeAutoSave();
      if (this.pageStayTracker) {
        this.pageStayTracker.destroy();
        this.pageStayTracker = null;
      }
      document.removeEventListener('click', this.documentClickHandler);
      window.removeEventListener('message', this.messageHandler);
    },
    getTemplateInfo: function getTemplateInfo() {
      var _this6 = this;

      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee4() {
        return _regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                _context4.prev = 0;
                _context4.next = 3;
                return _this6.$store.dispatch('creative/template/getTemplateInfo');

              case 3:
                if (!(_this6.hasJsonConfig && !_this6.isReadonly)) {
                  _context4.next = 6;
                  break;
                }

                _context4.next = 6;
                return _this6.getTemplateOriginalInfo();

              case 6:
                _this6.loading = false;
                _this6.triggerWinResize();
                _context4.next = 15;
                break;

              case 10:
                _context4.prev = 10;
                _context4.t0 = _context4['catch'](0);

                console.error(_context4.t0);
                _this6.loading = false;
                _this6.triggerWinResize();

              case 15:
              case 'end':
                return _context4.stop();
            }
          }
        }, _callee4, _this6, [[0, 10]]);
      }))();
    },
    triggerWinResize: function triggerWinResize() {
      // 部分布局使用js计算, 加载完内容触发一次resize
      var event = document.createEvent('HTMLEvents');
      event.initEvent('resize', true, true);
      window.dispatchEvent(event);
    },
    uploadComplete: function uploadComplete() {
      if (this.$refs['resourceManager'] && this.$refs['resourceManager'].refreshAssetData) {
        this.$refs['resourceManager'].refreshAssetData();
      }
    },
    handleClick: function handleClick() {
      this.updateAssetsDialog({
        visible: true,
        loading: false
      });
    },
    initRefresh: function initRefresh() {
      if (this.$refs['resourceManager'] && this.$refs['resourceManager'].initRefresh) {
        this.$refs['resourceManager'].initRefresh();
      }
    },

    // 一键替换下架字体
    handleUpdateForbiddenFont: function handleUpdateForbiddenFont(data) {
      this.updateForbiddenFontDialog({ loading: true });
      var replaceLanguage = dealForbiddenFont(data);
      this.updateI18nResourceByReplace(replaceLanguage);
      this.updateForbiddenFontDialog({ visible: false, loading: false });
    },
    handlePreview: function handlePreview(item) {
      var _this7 = this;

      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee5() {
        return _regeneratorRuntime.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                _this7.$store.dispatch('pt/delivery/previewPlayable', {
                  group_name: item.name,
                  product_name: item.name,
                  source_id: item.id,
                  custom_id: item.id,
                  preview_url: item.preview_url
                });

              case 1:
              case 'end':
                return _context5.stop();
            }
          }
        }, _callee5, _this7);
      }))();
    },
    closeTemplatePreviewerDialog: function closeTemplatePreviewerDialog() {
      this.$store.commit('pt/delivery/closeCreativePreviewerDialog');
    },
    handleOpenModelOrder: function handleOpenModelOrder() {
      this.modelProcessingData.visible = true;
      this.setCategoryId(this.currentCategory.id);
    },
    modelProcessingSubmit: function modelProcessingSubmit(data) {
      var _this8 = this;

      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee6() {
        var response;
        return _regeneratorRuntime.wrap(function _callee6$(_context6) {
          while (1) {
            switch (_context6.prev = _context6.next) {
              case 0:
                _this8.modelProcessingData.loading = true;
                _context6.prev = 1;
                _context6.next = 4;
                return _this8.$store.dispatch('creative/modelOrder/createModelOrder', {
                  materials: data.fileList.map(function (item) {
                    return {
                      name: item.name,
                      upload_url: _.get(item, 'response.data.file_path')
                    };
                  }),
                  remark: data.extra.remark,
                  usage_type: data.usage_type
                });

              case 4:
                response = _context6.sent;

                console.log('打印response', response);

                if (!(response.data.code === 0)) {
                  _context6.next = 13;
                  break;
                }

                _this8.modelProcessingData.visible = false;
                _this8.$message.success(_this8.$t('playTurbo.order.3dmodel.dialog.success'));
                _context6.next = 11;
                return _this8.getOrderList({
                  search_field: 'project_id',
                  keyword: _this8.templateId,
                  page: 1,
                  page_size: 1000
                });

              case 11:
                _context6.next = 14;
                break;

              case 13:
                _this8.$message.error(response.message);

              case 14:
                _context6.next = 19;
                break;

              case 16:
                _context6.prev = 16;
                _context6.t0 = _context6['catch'](1);

                console.error(_context6.t0);

              case 19:
                _context6.prev = 19;

                _this8.modelProcessingData.loading = false;
                return _context6.finish(19);

              case 22:
              case 'end':
                return _context6.stop();
            }
          }
        }, _callee6, _this8, [[1, 16, 19, 22]]);
      }))();
    }
  })
};